/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Bodyfat_Stale_NoteInputs */

const en_us2_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last measurement is over a month old. A new one makes the estimates more accurate.`)
};

const pt_br2_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A última medida tem mais de um mês. Uma nova deixa as estimativas mais precisas.`)
};

const es_419_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La última medición tiene más de un mes. Una nueva hace las estimaciones más precisas.`)
};

const pt_pt2_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A última medição tem mais de um mês. Uma nova torna as estimativas mais precisas.`)
};

const fr_fr2_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dernière mesure date de plus d'un mois. Une nouvelle rend les estimations plus précises.`)
};

const de_de2_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die letzte Messung ist über einen Monat alt. Eine neue macht die Schätzungen genauer.`)
};

const it_it2_profile_bodyfat_stale_note = /** @type {(inputs: Profile_Bodyfat_Stale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ultima misurazione ha più di un mese. Una nuova rende le stime più precise.`)
};

/**
* | output |
* | --- |
* | "The last measurement is over a month old. A new one makes the estimates more accurate." |
*
* @param {Profile_Bodyfat_Stale_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_stale_note = /** @type {((inputs?: Profile_Bodyfat_Stale_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_Stale_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_stale_note(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_stale_note(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_stale_note(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_stale_note(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_stale_note(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_stale_note(inputs)
	return en_us2_profile_bodyfat_stale_note(inputs)
});
export { profile_bodyfat_stale_note as "profile.bodyfat_stale_note" }